import React, { useEffect } from "react";

import { useToastNotifications } from "../hooks/useToastNotifications";

import { Toast } from "./Toast";

export const ToastContainer: React.FC = () => {
  const { closingToastIds, dismissFirstToast, dismissToast, hasAnyToasts, toasts } =
    useToastNotifications();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Escape") {
        return;
      }

      // Поведение как в mlops: не закрываем toast, если есть открытая модалка.
      const hasOpenModal = document.querySelector(".fixed.inset-0.z-50") !== null;
      if (hasOpenModal) {
        return;
      }

      if (hasAnyToasts) {
        dismissFirstToast();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [dismissFirstToast, hasAnyToasts]);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="toast-stack">
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          isClosing={closingToastIds.has(toast.id)}
          onClose={() => dismissToast(toast.id)}
          message={toast.message}
          link={toast.link}
          type={toast.type}
        />
      ))}
    </div>
  );
};
